export default __webpack_public_path__ + "static/l5-about-big-1171c377b334f5abb51314202e34fffe.jpg";